// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "about" + "." + "e04f8802bb8867b6" + ".js";
};